import {ChangeDetectorRef, Component, OnInit, AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd} from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { ClientSideNavService } from '../client-side-nav/services/client-side-nav.service';
import {MediaMatcher} from '@angular/cdk/layout';
import { ColorPaletteGeneratorService } from'@shared/components/color-palette-generator/color-palette-generator.service';
import { ClientLoaderService } from '../../../shared/components/client-loader/client-loader.service';
import { RbDinamicFaviconService } from '../../../shared/directives/rb-dinamic-favicon/rb-dinamic-favicon.service';
import { ApplymentModel } from 'src/app/core/services/client-general-settings/applyment/applyment.model';
import { environment } from '@env';

@Component({
  selector: 'app-content-layout-client',
  templateUrl: './content-layout-client.component.html',
  styleUrls: ['./content-layout-client.component.scss']
})
export class ContentLayoutClientComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('snav', {static: false}) public snav: MatSidenav;

  mobileQuery: MediaQueryList;
  // tslint:disable-next-line: variable-name
  private _mobileQueryListener: () => void;

  public env = environment;

  public customSettings: any = {};
  public theme: any = {
    rbMainPalette: '#0DA6A6',
    rbAccentPalette: '#717171',
    reduced_institutional_logo: 'assets/img/favicon.png',
  };

  public primaryPaletteSettings: any = {
    colors: [],
    orig: [],
    base: this.theme.rbMainPalette,
    json: '',
    name: '',
    angularCodeString: '',
  };
  public accentPaletteSettings: any = {
    colors: [],
    orig: [],
    base: this.theme.rbAccentPalette,
    json: '',
    name: '',
    angularCodeString: '',
  };

  constructor(
    private router: Router,
    public clientSideNavService: ClientSideNavService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private colorPaletteGeneratorService: ColorPaletteGeneratorService,
    private loaderService: ClientLoaderService,
    private rbDinamicFaviconService: RbDinamicFaviconService,
    public applymentModel: ApplymentModel,
  ) {
    // this.loaderService.setChangesLoaderState(true);
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
   }

  ngOnInit() {
    this.customSettings = this.applymentModel.getSettings();
    if (typeof this.customSettings.id === 'undefined') {
      this.router.navigate(['']);
    }
    this.themeManagement();
    this.faviconManagement();
  }

  ngOnDestroy() {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit(): void {
    this.clientSideNavService.setSidenav(this.snav);
    this.setLoaderRoutingControls();
    // this.loaderService.setChangesLoaderState(false);
  }

  setLoaderRoutingControls() {
    this.router.events
    .subscribe((event) => {
        if (event instanceof NavigationStart) {
          // this.loaderService.setChangesLoaderState(true);
        } else if (
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel
            ) {
          // this.loaderService.setChangesLoaderState(false);
        }
    });
  }


  themeManagement() {
    this.theme.rbMainPalette = this.customSettings.institutional_color;
    this.primaryPaletteSettings.base = this.customSettings.institutional_color;
    if (this.primaryPaletteSettings && !this.primaryPaletteSettings.base || this.primaryPaletteSettings.base === 'undefined') {
      this.primaryPaletteSettings.base = '#0DA6A6';
    }
    this.colorPaletteGeneratorService.changePalette(0, this.theme, 'rbMainPalette', this, 'primaryPaletteSettings');
    this.colorPaletteGeneratorService.changePalette(0, this.theme, 'rbAccentPalette', this, 'accentPaletteSettings');
    this.defineTheme();
  }

  defineTheme() {
    const newTheme = {
      rbMainPalette: this.primaryPaletteSettings.colors,
      rbAccentPalette: this.accentPaletteSettings.colors,
    };
    this.colorPaletteGeneratorService.changeTheme(newTheme, this.theme);
  }

  faviconManagement() {
    if (this.customSettings && this.customSettings.favicon) {
      this.rbDinamicFaviconService.setNewFavicon(this.env.storage_path + this.customSettings.favicon);
    }
  }

}
